import Hero from './components/Hero'
import Portfolio from './components/Portfolio'
import Products from './components/Products'
import Services from './components/Services'
import Founders from './components/Founders'
import Contact from './components/Contact'
import BgTransition from './components/BgTransition'
import Seo from './components/Seo'
import { useLocale } from './i18n/locale.jsx'
import { getSeo } from './i18n/seo'

// Homepage-ul (ruta „/").
export default function Home() {
  const seo = getSeo(useLocale()).home
  return (
    <>
      <Seo title={seo.title} description={seo.description} />
      <Hero />
      <Portfolio />
      <Products />
      {/* Respiro gol (forest) între What we build și What we do: lasă textul „why this
          works" să iasă complet din viewport ÎNAINTE ca bg-ul să comute verde→alb fix
          când rândul Finance intră de jos. */}
      <div data-theme="dark" aria-hidden className="h-[50vh] md:h-[85vh]" />
      <Services />
      {/* Crossfade lin bone → honey plin (climaxul CTA) */}
      <BgTransition from="#F0EBE0" to="#E8A33D" range={[0.18, 0.62]}>
        <Founders />
        <Contact />
      </BgTransition>
    </>
  )
}
